import React from "react";
import socialImg from "../../images/Social Media Reaction.png";
import group2 from "../../images/Group (2).png";
import { motion } from "framer-motion";

const HeaderSection = ({
  title = "See NKENNEAi At Work",
  description = "Test our translation and speech tools firsthand and see how NKENNEAi brings languages to life with real-time demos.",
  playgroundText = "PLAYGROUND",
}) => {
  return (
    <div className="flex flex-col md:flex-row justify-center items-center w-full min-h-[498px] gap-[20px] md:gap-[100px] p-4">
      <img
        src={group2}
        alt="Right decoration"
        className="absolute right-0 top-1/4 transform -translate-y-1/2 w-16 md:w-24"
      />
      {/* Left Content */}
      <div className="flex flex-col gap-2 text-center md:text-left">
        <span className="text-[#ef8702] font-extrabold text-base font-['Axiforma']">
          {playgroundText}
        </span>

        <div className="flex flex-col gap-3 mt-[35px]">
          <h1 className="text-black font-['Axiforma'] font-black text-[40px] md:text-[50px] max-w-[629px] leading-tight">
            {title}
          </h1>

          <p className="text-black  text-base max-w-[629px]">{description}</p>
        </div>
      </div>

      {/* Right Image */}

      <motion.img
        src={socialImg}
        alt="Social Media Reaction"
        className="w-[300px] h-[300px] md:w-[498px] md:h-[498px]"
        animate={{ opacity: 1, y: [20, -10, 20] }} // Moves up and down
        transition={{
          duration: 3,
          repeat: Infinity,
        }}
      />
    </div>
  );
};

export default HeaderSection;
